<template>
  <div>
    <div class="dataAnalysis">
      <div class="handle_box">
        <b>{{$t('dataAnalysis.deviceInfo')}}：</b>
        <span
          class="info_box">{{$t('dataAnalysis.project')}}：{{deviceInfo.projectName}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('dataAnalysis.lift')}}：{{deviceInfo.devNumber}}</span>
        <prowerSetting @selectStation="selectStation" :onLine="true" />
        <!-- <el-button class="refresh_button" icon="el-icon-refresh">重置</el-button> -->
      </div>
      <div class="handle_box">
        <span class="fz16 c8c8">{{$t('dataAnalysis.timeChs')}}：</span>
        <el-date-picker class="time-picker" v-model="query.date" type="datetimerange" range-separator="-"
          :start-placeholder="$t('dataAnalysis.startTime')" :end-placeholder="$t('dataAnalysis.endTime')">
        </el-date-picker>
        <span class="fz16 c8c8 ml20">{{$t('dataAnalysis.monitorchs')}}：</span>
        <el-select v-model="query.streamIds" clearable :placeholder="$t('dataAnalysis.pleCho')" @change="changesel" collapse-tags style="width:200px">
          <el-option v-for="(item,index) in options" :key="index" :label="item.monitorName" :value="item.streamId">
          </el-option>
        </el-select>
        <el-button type="primary" size="small" class="ml20 mr10" icon="el-icon-search" @click="getPage">{{$t('dataAnalysis.inquire')}}</el-button>
        <el-button class="refresh_button" icon="el-icon-refresh" @click="reset">{{$t('dataAnalysis.reset')}}</el-button>
      </div>
      <div class="switch_box">
        <el-button type="primary" @click="switchContent($event)" name="chart"
          :class="['switch_button', {'current': currentContent == 'chart'}]">
          <img src="~@/assets/img/chart.png" alt=""><span>{{$t('dataAnalysis.chart')}}</span>
        </el-button>
        <el-button type="primary" @click="switchContent($event)" name="table"
          :class="['switch_button', {'current': currentContent == 'table'}]">
          <img src="~@/assets/img/table.png" alt=""><span>{{$t('dataAnalysis.form')}}</span>
        </el-button>
        <!-- <el-button type="primary" @click="download" class="download_button">
          <img src="~@/assets/img/download.png" alt=""><span>导出</span>
        </el-button> -->
      </div>
      <div class="content" v-show="currentContent == 'chart'">
        <div class="chart" ref="chart" id='chart'></div>
        <div class="page_box">
          <el-button type="primary" size="small" class="ml20 mr10" plain @click="prevChartPage">{{$t('dataAnalysis.prev')}}</el-button>
          <el-button type="primary" size="small" class="ml20 mr10" plain @click="nextChartPage">{{$t('dataAnalysis.next')}}</el-button>
        </div>
      </div>
      <div class="content" v-show="currentContent == 'table'">
        <el-table :data="tableData" border class="table" style="width: 100%;">
          <el-table-column :label="$t('realdetile.serNum')" align="center">
            <template slot-scope="scope">
              {{scope.$index+1}}
            </template>
          </el-table-column>
          <el-table-column v-for="(item,index) in column" align="center" :prop='item.prop' :label="item.label"
            :width="item.width" :key="index"> </el-table-column>
        </el-table>
        <div class="page_box">
          <el-button type="primary" size="small" class="ml20 mr10" plain @click="prevTablePage">{{$t('dataAnalysis.prev')}}</el-button>
          <el-button type="primary" size="small" class="ml20 mr10" plain @click="nextTablePage">{{$t('dataAnalysis.next')}}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import prowerSetting from '@/components/power/prowerSetting';
import { devMonitorList, visualhistory, multiplehistory, projectinfo, deviceinfo } from "@/api/devicemon";
import Echarts from 'echarts'
import moment from 'moment'
import { mapGetters } from 'vuex';
export default {
  name: 'dataAnalysis',
  components: {
    prowerSetting
  },
  data() {
    return {
      deviceInfo: {
        devNumber: '',
        projectName: ''
      },
      query: {
        date: [moment().subtract(15, 'days').format("YYYY-MM-DD HH:mm:ss"),moment().format("YYYY-MM-DD HH:mm:ss")],
        streamIds: '',
      },
      options: [],
      currentContent: 'chart',
      // 图表
      chartData: {},
      // 表格
      tableData: [],
      column: [{ label: this.$t('dataAnalysis.time'), prop: 'time' }],
      // 图表分页
      chartDataList: [], // 储存查询过的图表数据
      currentChart: 0, // 当前图表索引
      chartCursor: '',
      // 表格分页
      tableDataList: [], // 储存查询过的tableData
      currentTable: 0, // 当前表格索引
      tableCursor: '',
      echartsUnit:'',
      tablename:''
    }
  },
  computed: {
    ...mapGetters(["stationObj"])
  },
  created() {

  },
  mounted() {
    // this.getPage()
    this.getdevMonitorList()
    this.getDeviceinfo()
  },
  watch: {
    currentContent: {
      handler(newVal, oldVal) {
        if (newVal == 'chart') {
          this.$nextTick(() => {
            // this.getChart()
          })
        }
      },
      deep: true //true 深度监听
    }
  },
  methods: {
    init() {
      this.query = {
        date: [],
        streamIds: '',
      }
      this.chartData = {}
      // 表格
      this.tableData = []
      this.column = [{ label: this.$t('dataAnalysis.time'), prop: 'time' }]
      // 图表分页
      this.chartDataList = [] // 储存查询过的图表数据
      this.currentChart = 0 // 当前图表索引
      this.chartCursor = ''
      // 表格分页
      this.tableDataList = [] // 储存查询过的tableData
      this.currentTable = 0 // 当前表格索引
      this.tableCursor = ''
    },
    // 重置搜索
    reset() {
      this.init()
      this.getPage()
    },
    changesel(val){
       let a = this.options.filter(v=>v.streamId===val)
       if(a.length>0){
         this.echartsUnit = a[0].unit
        //  this.tablename = a[0].monitorName
       }
    },
    // 获取默认设备信息
    getDeviceinfo() {
      projectinfo({ id: this.stationObj.proid?this.stationObj.proid:0 }).then(res => {
        if (res.status == 200) {
          this.deviceInfo.projectName = res.data.data.projectName
        }
      })
      deviceinfo({ id: this.stationObj.devid?this.stationObj.devid:0 }).then(res => {
        if (res.status == 200) {
          this.deviceInfo.devNumber = res.data.data.devNumber
        }
      })
    },
    // 表格
    getTableData() {
      let obj = {
        devCode: this.stationObj.devcode,
        streamIds: this.query.streamIds.toString(),
        beginTime: moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'),
        onenetId: this.stationObj.onenetId,
        limit: 20
      }
      if (this.tableCursor) {
        obj.cursor = this.tableCursor
      } else {
        obj.endTime = moment(this.query.date[1]).format('YYYY-MM-DDTHH:MM:SS')
      }
      visualhistory(obj).then(res => {
        this.tableData = []
        this.column = [{ label: this.$t('dataAnalysis.time'), prop: 'time' }]
        if (res.status == 200) {
          res.data.cursor ? this.tableCursor = res.data.cursor : this.tableCursor = ''
          res.data.categories && res.data.categories.map((item) => {
            this.tableData.push({ time: item })
          })
          res.data.series && res.data.series.map((item, index) => {
            this.column.push({
              label: item.name,
              prop: `val${index}`
            })
            item.data.map((v, i) => {
              if (this.tableData[i]) {
                this.tableData[i][`val${index}`] = v
              }

            })
          })
          this.tableDataList.push(this.tableData)
          this.currentTable = this.tableDataList.length - 1
        }
      })
    },
    // 图表
    getChartData() {
      // 历史数据
      let obj = {
        devCode: this.stationObj.devcode,
        streamIds: this.query.streamIds.toString(),
        beginTime: moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'),
        onenetId: this.stationObj.onenetId,
        limit: 20
      }
      if (this.chartCursor) {
        obj.cursor = this.chartCursor
      } else {
        obj.endTime = moment(this.query.date[1]).format('YYYY-MM-DDTHH:MM:SS')
      }
      visualhistory(obj).then(res => {
        this.chartData = {}
        if (res.status == 200) {
          // this.chartCursor = res?.data?.cursor
          res.data.cursor ? this.chartCursor = res.data.cursor : this.chartCursor = ''
          let arr = []
          let arr1 = []
          res.data.series && res.data.series.map((item, index) => {
            let obj = []
            item.data.map((v, i) => {
              obj.push(Number(v))
            })
           
              arr1.push({
                type: 'line',
                name: item.name,
               
                data: obj
              })
            
            
            arr.push(item.name)
          })
          this.chartData = { lval: arr, xval: res.data.categories, yval: arr1 }
          this.chartDataList.push(this.chartData)
          this.currentChart = this.chartDataList.length - 1
       
          this.getChart(this.chartData)
        }
      })
    },
    getdevMonitorList() {
      devMonitorList({ onenetId: this.stationObj.onenetId }).then(res => {
        if (res.data.code === 200) {
          this.options = res.data.data
          if(res.data.data.length>0){
             this.query.streamIds = res.data.data[0].streamId
             this.getPage()
          }
        }
      })
    },
    selectStation(data) {
      console.log(data)
      this.deviceInfo = {
        devNumber: data[0].devNumber,
        projectName: data[1].projectName
      }
    },
    switchContent(event) {
      this.currentContent = event.currentTarget.name;
      // if (this.currentContent == 'chart') {

      //   this.$nextTick(()=>{
      //     this.getChart()
      //   })
      // }
    },

    getPage() {
      this.chartCursor = ''
      this.chartData = { }
      this.chartDataList=[]
      this.currentChart = 0 
      this.getChartData()
      this.getTableData()
      // console.log(moment(this.query.date[0]).format('YYYY-MM-DDTHH:MM:SS'))
    },
    getChart(chartData) {
     
      let chart = Echarts.init(document.getElementById('chart'));
      chart.clear()
      const option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#FFFFFF',
          padding: 10,
          textStyle: {
            color: '#000000',
           
          },
          extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);',
          transitionDuration: 0
        },
        color: ['#319CFF', '#62D183'],
        legend: {
          data: chartData.lval,
          icon: 'rect'
        },
        grid: {
          // containLabel: true,
          // bottom: '-0.5%',
          x: 50
        },
        toolbox: {
          feature: {
            // saveAsImage: {}
          }
        },
        dataZoom: [
          {
            type: 'slider',//slider表示有滑动块的，inside表示内置的
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 100
          }
        ],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: chartData.xval
        },
        yAxis: {
          // show: false,
          name:`${this.$t('dataAnalysis.unit')} / ${this.echartsUnit}`,
          axisLine: {
            show: false,//不显示坐标轴线
          },
          type: 'value'
        },
        series: chartData.yval
      };
      
      chart.setOption(option, (window.onresize = chart.resize));
    },
    // 图表上一页
    prevChartPage() {
      // console.log(this.currentChart)
      if (this.currentChart == 0) {
        this.$message.warning(this.$t('dataAnalysis.alFirstPage'))
      } else {
        this.currentChart -= 1
        this.chartData = this.chartDataList[this.currentChart]
        this.getChart(this.chartData)
      }
    },
    // 图表下一页
    nextChartPage() {
      if (this.currentChart == this.chartDataList.length - 1 && this.chartCursor) {
        this.getChartData()
      } else if (this.currentChart == this.chartDataList.length - 1 && this.chartCursor == '') {
        this.$message.warning(this.$t('dataAnalysis.alLastPage'))
      } else {
        this.currentChart += 1
        this.chartData = this.chartDataList[this.currentChart]
        this.getChart(this.chartData)
      }
    },
    // 表格上一页
    prevTablePage() {
      // console.log(this.currentTable)
      if (this.currentTable == 0) {
        this.$message.warning(this.$t('dataAnalysis.alFirstPage'))
      } else {
        this.currentTable -= 1
        this.tableData = this.tableDataList[this.currentTable]
      }
    },
    // 表格下一页
    nextTablePage() {
      if (this.currentTable == this.tableDataList.length - 1 && this.tableCursor) {
        this.getTableData()
      } else if (this.currentTable >= this.tableDataList.length - 1 && this.tableCursor == '') {
        this.$message.warning(this.$t('dataAnalysis.alLastPage'))
      } else {
        this.currentTable += 1
        this.tableData = this.tableDataList[this.currentTable]
      }
    },
    // 导出
    download() {
      console.log('download');
    },
  }
}
</script>
<style lang='scss' scoped>
.dataAnalysis {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 20px 20px;
  .handle_box {
    padding: 15px 0;
    display: flex;
    align-items: center;
    b {
      font-size: 18px;
      padding-right: 5px;
    }
    .info_box {
      padding: 10px 20px 10px 20px;
      border: 1px solid #01aaa7;
      border-radius: 5px;
      color: #666666;
      font-size: 14px;
    }
    .prowerSetting {
      margin: 0 20px;
      display: inline-block;
    }
    .refresh_button {
      color: white;
      background: rgba(255, 131, 85, 1);
      border: rgba(255, 131, 85, 1);
    }
  }
  .switch_box {
    padding: 20px 0 30px;
    .switch_button,
    .download_button {
      background-color: #01aaa7;
      border: #01aaa7;
      // vertical-align: middle;
    }
    .switch_button img,
    .download_button img {
      width: 14px;
      height: 14px;
      padding-right: 10px;
    }
    .switch_button span,
    .download_button span {
      font-size: 15px;
    }
    .switch_button:hover,
    .switch_button:focus,
    .download_button:hover {
      background-color: #ffb540;
      border: #ffb540;
    }
    .current {
      background-color: #ffb540;
      border: #ffb540;
    }
  }
  .content {
    flex: 1;
    .chart {
      height: 500px;
    }
    .page_box {
      text-align: end;
      margin: 20px 0 0;
    }
  }
}
</style>